import { style, styleVariants } from '@vanilla-extract/css';
import { vars } from '../../theme/contract.css';

export const root = style({
  display: 'flex',
  alignItems: 'flex-start',
  gap: '4px',
  fontSize: vars.typography.fontSize.xs,
  fontWeight: vars.typography.fontWeight.medium,
  lineHeight: 1.4,
  selectors: {
    '&:empty': {
      display: 'none',
    },
  },
});

export const multiline = style({
  flexDirection: 'column',
  alignItems: 'flex-start',
});

export const level = styleVariants({
  error: { color: vars.bright.status.error },
  warning: { color: vars.bright.status.warning },
  info: { color: vars.bright.status.info },
});
